import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDown } from '@fortawesome/free-solid-svg-icons'
import banner from '../../images/banners/collect.jpg'
import loc from '../../images/quote/navi-icon.png'
import bus from '../../images/quote/fastbus-icon.png'
import printer from '../../images/quote/printer-icon.png'
import '../../Quote.css'
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Modal } from "react-bootstrap";
import BACKEND_URL from '../../api';
import { useCountry } from '../../context/CountryContext';

export default function QuoteList() {
    const { currency, weightUnit } = useCountry();
    const navigate = useNavigate()
    const location = useLocation();
    const [show, setShow] = useState(0)
    const [showindia, setShowindia] = useState([0])
    const [indiaNumber, setIndiaNumber] = useState(0)
    sessionStorage.removeItem('indiaquote');
    let inputs = JSON.parse(sessionStorage.getItem('qouteinput[]'))

    const [quotationType, setQuotationType] = useState(Array(inputs.length).fill(""));
    const [indiaQuotationType, setIndiaQuotationType] = useState(Array(inputs.length).fill(""));
    const [checkList, setCheckList] = useState(Array(inputs.length).fill(true));
    const [checkIndiaList, setCheckIndiaList] = useState(Array(inputs.length).fill(true));
    const downarrow = <FontAwesomeIcon icon={faAngleDown} />
    const show_details = {
        display: "block",
        backgroundColor: "#ffffff",
        marginBottom: "20px",
        marginLeft: "0",
        marginRight: 0,
    }

    const r_details = {
        marginBottom: "10px",
        backgroundColor: "#f9f9f9",
    }
    function setShowfunction(x) {
        let xx = show
        if (xx == 0) {
            setShow(1)
        } else {
            setShow(0)
        }
    }

    function setShowfunctionindia(x) {
        let yy = showindia
        if (yy == 0) {
            setShowindia(1)
        } else {
            setShowindia(0)
        }
    }
    const button_book = {
        background: "#3c50e0",
        color: "#fff",
        display: "inline-block",
        padding: "6px 25px",
        textTransform: " uppercase",
        borderColor: " #3c50e0",
        borderRadius: "6px",
        textDecoration: "none",
        textAlign: "center",
        marginRight: "50px",
        float: "right",
    }
    const button_book1 = {
        background: "#3c50e0",
        color: "#fff",
        display: "inline-block",
        padding: "6px 25px",
        textTransform: " uppercase",
        borderColor: " #3c50e0",
        borderRadius: "6px",
        marginLeft: "50px",
        textDecoration: "none",
        textAlign: "center",
        border: "none"
    }

    function indiaOrder() {
        const filteredItems = inputs.filter((item, index) => checkIndiaList[index] === true);
        console.log("~~~~~~~~~~~~~~~~", filteredItems)
        sessionStorage.setItem('qouteinput[]', JSON.stringify(filteredItems));

        sessionStorage.setItem('indiaquote', 1)
        navigate('/orderlist-detail')
    }

    const userid = sessionStorage.getItem('userid');
    const [indiarate, setindiarate] = useState([])
    const [indiabase, setindia_base] = useState([])
    const [indiadiscount, setindiadiscount] = useState([])
    const [indiagovtlevy, setindiaindiagovtlevy] = useState([])
    const [india_es, setindiaindia_es] = useState([])
    useEffect(() => {
        let number = 0;
        inputs.forEach((input, index) => {
            const { destination, typediv } = input;
            const { weight, chargable_weight } = location.state[index];
            console.log("----------", destination, location.state)
            if ((destination === 'IN' || destination === 'PH' || destination === 'PK') && weight <= 2) {
                number = number + 1;
                fetch(`${BACKEND_URL}/isUserDiscount`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        userid: userid,
                        typediv: typediv,
                        destination: destination,
                        weight: weight,
                        dimensional_weight: chargable_weight,
                    }),
                })
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error('Network response was not ok');
                        }
                        return response.json();
                    })
                    .then((data) => {
                        console.log("isUserDiscount----------", data);
                        // Update state in a single operation to avoid multiple re-renders
                        setindiadiscount(prev => {
                            const newDiscounts = [...prev];
                            newDiscounts[index] = data.discount;
                            return newDiscounts;
                        });
                        setindiarate(prev => {
                            const newRates = [...prev];
                            newRates[index] = data.rate;
                            return newRates;
                        });
                        setindia_base(prev => {
                            const newBases = [...prev];
                            newBases[index] = data.base;
                            return newBases;
                        });
                        setindiaindiagovtlevy(prev => {
                            const newGovtLevies = [...prev];
                            newGovtLevies[index] = data.govt_levy;
                            return newGovtLevies;
                        });
                        setindiaindia_es(prev => {
                            const newEmergencies = [...prev];
                            newEmergencies[index] = data.emergency;
                            return newEmergencies;
                        });
                    })
                    .catch((error) => console.error(error.message));
            }
        });

        setIndiaNumber(number);
    }, [])

    const [promocountry, setPromocountry] = useState(false);
    const handleClose = () => setPromocountry(false);
    const [loadingshow, setloadingshow] = useState(false);
    const [details, setdetails] = useState();
    const INTEGRA_URL = process.env.REACT_APP_INTEGRA_URL;
    const [msgerr, setmsgerr] = useState();
    const [msgsucc, setmsgsucc] = useState();


    function Country_promo() {
        setloadingshow(true);
        console.log(details);
        setmsgsucc();
        setmsgerr();

        fetch(`${BACKEND_URL}/promoCountryEmail`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json" // Set the content type to JSON
            },
            body: JSON.stringify({
                email: details.email,
                name: details.name,
                phone: details.phone,
            }) // Convert the details object to a JSON string
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json(); // Parse the JSON from the response
            })
            .then((data) => {
                setloadingshow(false);
                if (data.result !== "Successfully") {
                    setmsgerr(data.result);
                } else {
                    setmsgsucc(data.result);
                    setTimeout(() => {
                        setPromocountry(false);
                    }, 3000);
                }
            })
            .catch((error) => {
                console.error('There was a problem with the fetch operation:', error);
                setloadingshow(false);
                setmsgerr("An error occurred while processing your request.");
            });
    }

    const [text1, setText1] = useState('');
    const [text2, setText2] = useState('');
    const [text3, setText3] = useState('');
    const [text4, setText4] = useState('');
    const [text5, setText5] = useState('');
    const [text6, setText6] = useState('');
    const [text7, setText7] = useState('');
    const [promo_status, setPromo_status] = useState('');
    const [country_code, setCountry_code] = useState('');

    useEffect(() => {
        fetch(`${BACKEND_URL}/promoCountryStatus`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok ' + response.statusText);
                }
                return response.json(); // Parse the JSON from the response
            })
            .then((data) => {
                console.log("promoCountryStatus---------", data)
                setText1(data.text_one);
                setText2(data.text_two);
                setText3(data.text_three);
                setText4(data.text_four);
                setText5(data.text_five);
                setText6(data.text_six);
                setText7(data.text_seven);
                setPromo_status(data.promo_status);
                setCountry_code(data.country_code);

                // Check conditions for setting promocountry
                if (inputs['destination'] === data.country_code && data.promo_status === 'promo-valid') {
                    setPromocountry(true);
                }
            })
            .catch((error) => {
                console.error('There was a problem with the fetch operation:', error);
            });
    }, [])

    return (
        <div className='quote'>
            <Helmet>
                <title>Shypv | Quotation</title>
            </Helmet>
            <section className="your_business_page fw" style={{ backgroundImage: `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
                <div className="container"><div className="row">
                    <div className="col-md-12 col-sm-12 your_business text-center">
                        <div className="business_content">
                            <h1 className="mainhead">QUOTATION</h1>

                        </div>
                    </div>
                </div>
                </div>
            </section>
            <div className="pages_content">
                <div className="container">
                    <div className="row">
                        <div id="primary" className="content-area" style={{ float: 'left', width: '100%' }}>
                            <main id="main" className="site-main" role="main">
                                <div className="entry-content" style={{ background: "#fff", scrollPaddingBottom: "20px" }}>
                                    <div className="become_driver">

                                        <div className="col-md-12">
                                            {(inputs['destination'] == 'IN' || inputs['destination'] == 'PH' || inputs['destination'] == 'PK') && location.state.weight <= 2 && location.state.chargable_weight <= 2 ? (
                                                <h5>EXPRESS</h5>
                                            ) : null}
                                            <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>

                                                <table className='table table-bordered table-striped quotetable fordesk'>
                                                    <thead>
                                                        <tr>
                                                            <th>Weight ({weightUnit})</th>
                                                            <th>Volumetric Weight ({weightUnit})</th>
                                                            <th>Destination</th>
                                                            <th>Carrier</th>
                                                            <th>Transit Time (Days)</th>
                                                            <th>Total Price</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            inputs.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{location.state[index].weight}</td>
                                                                    <td>{location.state[index].chargable_weight}</td>
                                                                    <td>{inputs[index]['destination']}</td>
                                                                    <td>{location.state[index].carrier || 'DHL'}</td>
                                                                    <td>{location.state[index].get_transit_time}</td>
                                                                    <td>
                                                                        {location.state[index].qoute_rate} {currency}
                                                                        {
                                                                            inputs.length == index + 1 &&
                                                                            <span className="r_more_details" onClick={() => setShowfunction(1)}>
                                                                                More Details <i className="fa fa-angle-down" aria-hidden="true" />{downarrow}
                                                                            </span>
                                                                        }
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        }
                                                    </tbody>
                                                </table>
                                                <div className="table-responsive other-option formobile">
                                                    {
                                                        inputs.map((item, index) => (
                                                            <table className="table-bordered table-striped table-hover table" id="price-table" key={index}>
                                                                <thead>
                                                                    <tr>
                                                                        <th>Description</th>
                                                                        <th>Total Shipping Price ({currency})</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr>
                                                                        <td>Weight (Kg)</td>
                                                                        <td className="total-price" style={{ width: "65%" }}>{location.state[index].weight}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Volumetric Weight (Kg)</td>
                                                                        <td className="total-price">{location.state[index].chargable_weight}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Destination</td>
                                                                        <td className="total-price">{inputs[index]['destination']}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Transit Time (Days)</td>
                                                                        <td className="total-price">{location.state[index].get_transit_time}</td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td>Total Price</td>
                                                                        <td className="total-price">
                                                                            {location.state[index].qoute_rate} {currency}
                                                                            {
                                                                                inputs.length == index + 1 &&
                                                                                <span className="r_more_details" onClick={() => setShowfunction(1)}>
                                                                                    More Details <i className="fa fa-angle-down" aria-hidden="true" />{downarrow}
                                                                                </span>
                                                                            }
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        ))
                                                    }
                                                </div>

                                            </div>
                                        </div>

                                        {show && show > 0 ? (
                                            inputs.map((item, index) => (
                                                <div className="row show_details" style={show_details} key={index}>
                                                    <div className="col-md-3">&nbsp;</div>
                                                    <div className="col-md-6" style={{ padding: '12px 0px', margin: "0 auto" }}>
                                                        <div className="r_details" style={r_details}>
                                                            <ul>
                                                                <li>Transportation Charge</li>
                                                                <li className="r-right">{location.state[index].basic} <i className="fa fa-times-circle close_details" aria-hidden="true" /></li>
                                                            </ul>
                                                        </div>
                                                        {location.state[index].charge_rate > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>{location.state[index].get_gov_vat}</li>
                                                                    <li className="r-right">{location.state[index].charge_rate}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        {location.state[index].es_surcharge > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>Emergency Situation Surcharge</li>
                                                                    <li className="r-right">{location.state[index].es_surcharge}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        {location.state[index].oversize > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>Oversize Charge</li>
                                                                    <li className="r-right">{location.state[index].oversize}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        {location.state[index].er_charge > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>Elevated Risk Charge</li>
                                                                    <li className="r-right">{location.state[index].er_charge}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        {location.state[index].rd_charge > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>Restricted Destination Charge</li>
                                                                    <li className="r-right">{location.state[index].rd_charge}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        {location.state[index].demand_surcharge > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>Demand Surcharge</li>
                                                                    <li className="r-right">{location.state[index].demand_surcharge}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        {location.state[index].user_discount > 0 && (
                                                            <div className="r_details" style={r_details}>
                                                                <ul>
                                                                    <li>{location.state[index].user_text}</li>
                                                                    <li className="r-right">- {location.state[index].user_discount}</li>
                                                                </ul>
                                                            </div>
                                                        )}
                                                        <div className="r_details" style={r_details}>
                                                            <ul>
                                                                <li style={{ fontWeight: 'bold' }}>Total</li>
                                                                <li className="r-right" style={{ fontWeight: 'bold' }}>{location.state[index].qoute_rate} {currency}</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-3">&nbsp;</div>

                                                    <div className="col-md-12">
                                                        <div className="submit content-area form-select-button">
                                                            <select
                                                                className="form-select"
                                                                value={quotationType[index]}
                                                                style={{ height: '100%' }}
                                                                onChange={(e) => {
                                                                    const newQuotationType = [...quotationType]; // Create a copy of the current array
                                                                    newQuotationType[index] = e.target.value; // Update the specific index with the new value
                                                                    setQuotationType(newQuotationType); // Set the new array as the state
                                                                }}
                                                            >
                                                                <option value="">Select Carrier</option>
                                                                {
                                                                    inputs[index].shipmenttype == "domestic" ? (
                                                                        <>
                                                                            <option value="Aramex">Aramex</option>
                                                                            <option value="Emirates Post">Emirates Post</option>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <option value="DHL">DHL</option>
                                                                            <option value="Fedex">Fedex</option>
                                                                            <option value="UPS">UPS</option>
                                                                            <option value="Aramex">Aramex</option>
                                                                        </>
                                                                    )
                                                                }
                                                            </select>
                                                            <input
                                                                type="checkbox"
                                                                name="Sectors"
                                                                style={{ width: '20px', height: '20px' }}
                                                                checked={checkList[index]} // Use checked to determine if the checkbox is checked
                                                                onChange={(e) => {
                                                                    const newCheckList = [...checkList]; // Create a copy of the current array
                                                                    newCheckList[index] = e.target.checked; // Update the specific index with the new checked state
                                                                    setCheckList(newCheckList); // Set the new array as the state
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : null}

                                        <Link to="/orderlist-detail" style={button_book} onClick={() => {
                                            inputs.map((item, index) => {
                                                item.quotationType = quotationType[index];
                                            })
                                            const filteredItems = inputs.filter((item, index) => checkList[index] === true);
                                            sessionStorage.setItem('qouteinput[]', JSON.stringify(filteredItems));
                                        }}>Book Now</Link>

                                    </div>

                                    {
                                        indiaNumber > 0 && (
                                            <div className="become_driver" style={{ display: 'flex', flexDirection: 'column' }}>
                                                <div className="col-md-12">
                                                    <h5>ECONOMY</h5>
                                                    <div id="primary" className="content-area" style={{ float: 'left', padding: '3%', width: "100%" }}>
                                                        <table className='table table-bordered table-striped quotetable fordesk'>
                                                            <thead>
                                                                <tr>
                                                                    <th>Weight (Kg)</th>
                                                                    <th>Volumetric Weight (Kg)</th>
                                                                    <th>Destination</th>
                                                                    <th>Transit Time (Days)</th>
                                                                    <th>Total Price</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {inputs.map((input, index) => (
                                                                    indiarate[index] && (
                                                                        <tr key={index}>
                                                                            <td>{location.state[index].weight}</td>
                                                                            <td>{location.state[index].chargable_weight}</td>
                                                                            <td>{input['destination']}</td>
                                                                            <td>6</td>
                                                                            <td>
                                                                                {indiarate[index]} {currency}
                                                                                {index === inputs.length - 1 && (
                                                                                    <span className="r_more_details" onClick={() => setShowfunctionindia(1)}>
                                                                                        More Details <i className="fa fa-angle-down" aria-hidden="true" />{downarrow}
                                                                                    </span>
                                                                                )}
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                ))}
                                                            </tbody>
                                                        </table>

                                                        <div className="table-responsive other-option formobile">
                                                            {inputs.map((input, index) => (
                                                                indiarate[index] && (
                                                                    <table className="table-bordered table-striped table-hover table" id="price-table" key={index}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th>Description</th>
                                                                                <th>Total Shipping Price ({currency})</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr key={`weight-${index}`}>
                                                                                <td>Weight (Kg)</td>
                                                                                <td className="total-price" style={{ width: "65%" }}>{location.state[index].weight}</td>
                                                                            </tr>
                                                                            <tr key={`volumetric-weight-${index}`}>
                                                                                <td>Volumetric Weight (Kg)</td>
                                                                                <td className="total-price">{location.state[index].chargable_weight}</td>
                                                                            </tr>
                                                                            <tr key={`destination-${index}`}>
                                                                                <td>Destination</td>
                                                                                <td className="total-price">{inputs[index]['destination']}</td>
                                                                            </tr>
                                                                            <tr key={`transit-time-${index}`}>
                                                                                <td>Transit Time (Days)</td>
                                                                                <td className="total-price">6</td>
                                                                            </tr>
                                                                            <tr key={`total-price-${index}`}>
                                                                                <td>Total Price</td>
                                                                                <td className="total-price">
                                                                                    {indiarate[index]} {currency}
                                                                                    {
                                                                                        inputs.length == index + 1 &&
                                                                                        <span className="r_more_details" onClick={() => setShowfunctionindia(1)}>
                                                                                            More Details <i className="fa fa-angle-down" aria-hidden="true" />{downarrow}
                                                                                        </span>
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                )
                                                            ))}
                                                        </div>

                                                        {showindia && showindia > 0 ? (
                                                            inputs.map((input, index) => (
                                                                indiarate[index] && (
                                                                    <div className="row show_details" style={show_details} key={index}>
                                                                        <div className="col-md-3">&nbsp;</div>
                                                                        <div className="col-md-6" style={{ padding: '12px 0px', margin: "0 auto" }}>
                                                                            <div className="r_details" style={r_details}>
                                                                                <ul>
                                                                                    <li>Transportation Charge</li>
                                                                                    <li className="r-right">
                                                                                        {indiabase}
                                                                                        <i className="fa fa-times-circle close_details" aria-hidden="true" />
                                                                                    </li>
                                                                                </ul>
                                                                            </div>
                                                                            {indiadiscount[index] > 0 && (
                                                                                <div className="r_details" style={r_details}>
                                                                                    <ul>
                                                                                        <li>User Discount D-Rate (20%)</li>
                                                                                        <li className="r-right">- {indiadiscount[index]}</li>
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                            {indiagovtlevy[index] > 0 && (
                                                                                <div className="r_details" style={r_details}>
                                                                                    <ul>
                                                                                        <li>Mail Service Process (10%)</li>
                                                                                        <li className="r-right">{indiagovtlevy[index]}</li>
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                            {india_es[index] > 0 && (
                                                                                <div className="r_details" style={r_details}>
                                                                                    <ul>
                                                                                        <li>Emergency Situation Surcharge</li>
                                                                                        <li className="r-right">{india_es[index]}</li>
                                                                                    </ul>
                                                                                </div>
                                                                            )}
                                                                            <div className="r_details" style={r_details}>
                                                                                <ul>
                                                                                    <li style={{ fontWeight: 'bold' }}>Total</li>
                                                                                    <li className="r-right" style={{ fontWeight: 'bold' }}>{indiarate[index]} {currency}</li>
                                                                                </ul>
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-3">&nbsp;</div>

                                                                        <div className="col-md-12">
                                                                            <div className="submit content-area form-select-button" style={{ margin: "0px" }}>
                                                                                <select
                                                                                    className="form-select"
                                                                                    value={indiaQuotationType[index]}
                                                                                    style={{ height: '100%' }}
                                                                                    onChange={(e) => {
                                                                                        const newQuotationType = [...indiaQuotationType]; // Create a copy of the current array
                                                                                        newQuotationType[index] = e.target.value; // Update the specific index with the new value
                                                                                        setIndiaQuotationType(newQuotationType); // Set the new array as the state
                                                                                    }}
                                                                                >
                                                                                    <option value="">Select Carrier</option>
                                                                                    {
                                                                                        inputs[index].shipmenttype == "domestic" ? (
                                                                                            <>
                                                                                                <option value="Aramex">Aramex</option>
                                                                                                <option value="Emirates Post">Emirates Post</option>
                                                                                            </>
                                                                                        ) : (
                                                                                            <>
                                                                                                <option value="DHL">DHL</option>
                                                                                                <option value="Fedex">Fedex</option>
                                                                                                <option value="UPS">UPS</option>
                                                                                                <option value="Aramex">Aramex</option>
                                                                                            </>
                                                                                        )
                                                                                    }
                                                                                </select>
                                                                                <input
                                                                                    type="checkbox"
                                                                                    name="Sectors"
                                                                                    style={{ width: '20px', height: '20px' }}
                                                                                    checked={checkIndiaList[index]} // Use checked to determine if the checkbox is checked
                                                                                    onChange={(e) => {
                                                                                        const newCheckList = [...checkIndiaList]; // Create a copy of the current array
                                                                                        newCheckList[index] = e.target.checked; // Update the specific index with the new checked state
                                                                                        setCheckIndiaList(newCheckList); // Set the new array as the state
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )
                                                            ))
                                                        ) : null}
                                                        <div className="col-md-12">
                                                            <div className="submit" style={{ float: "right" }}>
                                                                <button onClick={() => indiaOrder()} style={button_book1}>Book Now</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }

                                    <div className="col-md-12" style={{ display: "flex", width: "100%" }}>
                                        <div className="content-serv border_text" style={{ padding: "3%", border: "5px solid #f5f5f5", margin: "3%", width: "100%" }}>
                                            <div className="row mainbox">
                                                <div className="col-md-2 quotefirst quotebox">
                                                    <img src={loc} style={{ width: "30%" }} className=" " />
                                                    <p>Fully Tracked</p>
                                                </div>
                                                <div className="col-md-2 quotebox">
                                                    <img src={bus} style={{ width: "30%" }} />
                                                    <p>Collection Service</p>
                                                </div>
                                                <div className="col-md-2 quotebox">
                                                    <img src={printer} style={{ width: "30%" }} />
                                                    <p>Printer Required</p>
                                                </div>
                                            </div>
                                            <h3>TERMS AND CONDITIONS</h3>
                                            <p>All domestic shipments will be subjected to a 10% mail service process regardless of weight.</p>
                                            <p>Non Document shipments up to 30 kilograms and all Document shipments are subject to a 10% mail service process.</p>
                                            <p>Customs duties, taxes, clearance-related charges and other surcharges are not included in the tariffs.</p>
                                            <p>Fuel surcharge is included in the rates.</p>
                                            <p>The Rates as set out in this rate card are valid only until December 31 of the year the Rates are quoted.</p>
                                            <p>The Rates are subject to a General Price Increase (GPI) effective January 1st of each year.</p>
                                            <p>Shypv reserves the right to revise the Rates at any time upon shortfall on the projected volumes.</p>
                                            <p>Shypv Terms and Conditions of Carriage will apply for all Shypv services.</p>
                                            <p>Heavyweight rate per kilo may differ from weight break price.</p>
                                            <p>International shipments require invoice and packing list.</p>
                                            <p>Customer agrees to pay shipping charges cash upon collection.</p>
                                            <p>Remote locations, overweight/oversize packages, address correction, elevated risks, restricted destinations are subject to surcharge.</p>
                                            <p>Emergency situation surcharge applies from 1st April 2020.</p>
                                            <p>Cancellation charges 50dhs apply for refunds, credit note free of charge valid 6 months.</p>
                                            <p>Charges based on volumetric or Actual weight: Length x Width x Height (cm3) / 5000 = Volumetric Weight (kg).</p>
                                            {inputs['origin'] == 'DXB' || inputs['origin'] == 'AUH' ? (<p>Additional {currency} 180 applicable for Embassy pickup.</p>) : null}
                                            <p> The transit time mentioned is excluding weekends & holidays at the destination.</p>
                                            <p>Transit time is subject to custom clearance & inspection.</p>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </div>
                    </div>
                </div>
            </div>

            <Modal show={promocountry} className="promocountry" onHide={handleClose}>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <div className="row">
                            <div className="col-md-5 promobgimg">

                            </div>
                            <div className="col-md-7">
                                <div className="promohol">
                                    <h3 className="first-t1">{text1}</h3>
                                    <h2 className="first-t2">{text2} <span>{text3}</span> {text4}</h2>
                                    <h2 className="first-t3">{text5}</h2>
                                    <h2 className="first-t2">{text6}</h2>
                                    <p className="first-t4">{text7}</p>

                                    <form className="form-promo-country">
                                        <input type="text" placeholder='Name' className="form-control mb-3" onChange={(e) => setdetails({ ...details, name: e.target.value })} />
                                        <input type="text" placeholder='Email' className="form-control mb-3" onChange={(e) => setdetails({ ...details, email: e.target.value })} />
                                        <input type="text" placeholder='Phone' className="form-control mb-3" onChange={(e) => setdetails({ ...details, phone: e.target.value })} />
                                        <div className="promo-submit">

                                            {msgerr ?
                                                (
                                                    <div className="alert alert-danger">
                                                        <strong>{msgerr}</strong>
                                                    </div>
                                                ) : null
                                            }
                                            {msgsucc ?
                                                (
                                                    <div className="alert alert-success">
                                                        <strong>Details Send Successfully!</strong>
                                                    </div>
                                                ) : null
                                            }

                                            {loadingshow ?
                                                (
                                                    <span className="rloader"></span>
                                                ) : (
                                                    <button type="button" className="btn  btn-sm" style={{ backgroundColor: '#4e25b8', color: "#fff", padding: "2%", width: "19%" }} onClick={Country_promo}>Submit</button>
                                                )
                                            }
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </>
                </Modal.Body>
            </Modal>
        </div>
    )
}